import tw from 'twin.macro';
import styled from 'styled-components';

export const PageWrapper = tw.div`mx-auto
 flex flex-col h-screen relative pt-12`;

export const UpperPartWrap = tw.div`flex sticky justify-between`;

export const UpperTittleWrap = tw.div`text-blue-700`;

export const H6 = tw.h6`text-xs xl:text-sm font-semibold`;

export const H2 = tw.h2`text-2xl font-semibold tracking-wider`;

export const SearchBar = tw.input`py-2 px-4 w-128 text-sm
 bg-gray-100 border border-gray-200 rounded-md outline-none`;

export const SearchBarWrap = tw.div`relative`;

export const SearchIcon = styled.i`
  ${({ disabled }: { disabled?: boolean }) =>
    disabled ? tw`text-gray-400 cursor-not-allowed` : tw`text-blue-600`}
  ${tw`right-5 top-1  text-xl absolute cursor-pointer hover:text-blue-800`}
`;

export const TableWrap = tw.div`mt-16`;

export const Table = tw.div``;

export const Thead = tw.div`bg-white text-base 2xl:text-lg
 font-medium grid grid-cols-16 gap-1 w-full py-3`;

export const DateDiv = tw.div`pl-2 col-span-4 text-left`;

export const Name = tw.div`col-span-4 text-left`;

export const Session = tw.div`col-span-1 -ml-2 text-left`;

export const Duration = tw.div`col-span-3 text-left`;

export const Room = tw.div`col-span-2 ml-3 text-left`;

export const Signature = tw.div`col-span-2`;

export const Tr = tw.div`bg-gray-100 grid items-center
 grid-cols-16 gap-1 w-full py-1 font-semibold text-sm 2xl:text-base rounded-lg lg:mt-4`;

export const Tableheader = tw.div`mb-2 flex justify-between`;

export const Sortby = tw.div`flex gap-3 relative`;

const FilterbyBut = styled.span`
  ${tw`px-3 text-white text-xs  select-none 2xl:text-base font-medium
 rounded-2xl mx-2 py-1 cursor-pointer text-center`}
`;

export const ActiveSortOption = styled.div`
  ${({ isActive }: { isActive: boolean }) =>
    isActive ? tw`h-1 w-8 rounded-full mt-2 bg-gray-300` : tw`hidden`}
`;

export const SignatureImgWrap = tw.div`rounded-xl w-20 flex justify-center items-center 
 h-16  p-1 border border-blue-700`;

export const FilterByDateButton = tw(FilterbyBut)`bg-blue-800`;

export const FilterbySessionButton = tw(FilterbyBut)`bg-blue-400 `;

export const FilterbyPayrollButton = tw(FilterbyBut)`bg-blue-600`;

export const Pagination = tw.div`2xl:text-2xl text-base text-gray-600`;

export const PaginationIcon = tw.i`text-xl cursor-pointer mx-2`;

export const ActionSortby = tw.div``;

export const SearchSpan = styled.span`
  ${({ isActive }: { isActive: boolean }) => (isActive ? tw`bg-gray-300 rounded-sm` : tw``)}
  ${tw`mb-1 border-b cursor-pointer hover:text-gray-900
 border-gray-200 font-semibold px-2`}
`;

export const DropdownWrap = styled.div`
  ${({ show }: { show: boolean }) => (show ? tw`flex` : tw`hidden`)}
  ${tw` gap-2 select-none py-3 px-2 bg-gray-100 w-32 rounded-md absolute top-12 right-0 z-50 
 flex-col shadow-md`}
`;

export const SesssionDropdownWrap = styled.div`
  ${({ show }: { show: boolean }) => (show ? tw`flex flex-col` : tw`hidden`)}
  ${tw`text-center bg-blue-100 absolute shadow-xl top-8 select-none z-50 left-[165px]`}
`;

export const SessionDropdownItem = styled.span`
  ${({ isActive }: { isActive: boolean }) => (isActive ? tw`bg-gray-300! rounded-sm` : tw``)}
  ${tw`px-4 py-1 border border-blue-200 bg-gray-50 hover:bg-blue-200 cursor-pointer font-bold`}
`;
